const baseUrl = process.env.REACT_APP_API_ENDPOINT;

export default {
  apiV1ChatsPath: () => `${baseUrl}/api/v1/chats`,
  apiV1ChatPath: uid => `${baseUrl}/api/v1/chats/${uid}`,
  apiV1FirebaseTokenPath: () => `${baseUrl}/api/v1/firebase_token`,
  presignUrlPath: () => `${baseUrl}/s3/params`,
  apiV1SignUrlPath: () => `${baseUrl}/api/v1/sign_url`,
  apiV1NotificationsPath: () => `${baseUrl}/api/v1/notifications`,
  apiV1OauthGoogleAuthenticationPath: () => `${baseUrl}/api/v1/oauth/google_authentication`,

  apiV1PublicRealEstateAgentsPath: slug => `${baseUrl}/api/v1/public/real_estate_agents/${slug}`,
  apiV1PublicBuyerLoanOfficersPath: () => `${baseUrl}/api/v1/public/buyer/loan_officers`,

  apiV1BuyerLoanOfficersBidRequestsPath: () => `${baseUrl}/api/v1/buyer/loan_officers/bid_requests/`,

  apiV1LoanOfficerRealEstateAgentsPath: () => `${baseUrl}/api/v1/loan_officer/real_estate_agents`,
  apiV1LoanOfficerWaitlistRealEstateAgentLoanOfficersPath: () =>
    `${baseUrl}/api/v1/loan_officer/waitlist_real_estate_agent_loan_officers`,

  apiV1RealEstateAgentWaitlistLoanOfficersPath: () => `${baseUrl}/api/v1/real_estate_agent/waitlist_loan_officers`,
  apiV1RealEstateAgentWaitlistLoanOfficerPath: id => `${baseUrl}/api/v1/real_estate_agent/waitlist_loan_officers/${id}`,
  apiV1RealEstateAgentWaitlistLoanOfficersBatchUpdatePath: () =>
    `${baseUrl}/api/v1/real_estate_agent/waitlist_loan_officers/batch_update`,

  loanOfficerBidRequestsPath: () => `${baseUrl}/loan_officers/bid_requests`,
  loanOfficerBidRequestPath: bidRequestId => `${baseUrl}/loan_officers/bid_requests/${bidRequestId}`,
  loanOfficerDashboardPath: () => `${baseUrl}/loan_officers/lo_my_bundle`,
  loanOfficerOfferingsPath: () => `${baseUrl}/loan_officer_offerings`,
  loanOfficerBidsPath: () => `${baseUrl}/loan_officers/bids`,
  loanOfficerStatesPath: () => `${baseUrl}/states`,
  loanOfficerRequestApproveProfilePath: () => `${baseUrl}/loan_officers/profile/request_approve`,
  loanOfficerSubscriptionInfoPath: () => `${baseUrl}/loan_officers/subscription_info`,
  loanOfficerSubscriptionPath: () => `${baseUrl}/loan_officers/save_subscriptions`,
  loanOfficerCreditCardPath: () => `${baseUrl}/loan_officers/save_card`,

  authUpdateLoanOfficerPath: () => `${baseUrl}/auth/update_loan_officer`,
  authUpdateRealEstateAgentPath: () => `${baseUrl}/auth/update_real_estate_agent`,
  authResendEmailComfirmationPath: () => `${baseUrl}/auth/resend_email_confirmation`,
  authValidateTokenPath: () => `${baseUrl}/auth/validate_token`,
  registrationPath: () => `${baseUrl}/auth`,

  buyerMyBundlePath: () => `${baseUrl}/buyers/my_bundle`,
  buyerBidsPath: () => `${baseUrl}/buyers/bids`,
  buyerBidRequestPath: () => `${baseUrl}/buyers/bids/bid_request`,
  buyerOpenBidRequestPath: () => `${baseUrl}/buyers/bids/open_bid_request`,
  buyerSaveAndOpenBidRequest: () => `${baseUrl}/buyers/bids/save_and_open_bid_request`,
  buyersRealEstateAgentReferralPath: slug => `${baseUrl}/buyers/real_estate_agents/${slug}/referral`,
  buyerSettingsPath: () => `${baseUrl}/auth/update_buyer`,

  signInPath: () => `${baseUrl}/auth/sign_in`,
  signOutPath: () => `${baseUrl}/auth/sign_out`,
  authPasswordPath: () => `${baseUrl}/auth/password`,

  saveProfileVideoPath: () => `${baseUrl}/uploads/profile_video_uploaded`,
  saveProfileImagePath: () => `${baseUrl}/uploads/profile_image_uploaded`,
  saveCompanyLogoPath: () => `${baseUrl}/uploads/company_logo_uploaded`,

  administratorsLoanOfficersPath: () => `${baseUrl}/administrators/loan_officers`,
  administratorsLoanOfficerPath: id => `${baseUrl}/administrators/loan_officers/${id}`,
  administratorsLoanOfficersApproveProfilePath: () => `${baseUrl}/administrators/loan_officers/approve_profile`,

  realEstateAgentLoanOfficersPath: () => `${baseUrl}/real_estate_agents/loan_officers`,
  realEstateAgentLoanOfficerMembershipPath: id => `${baseUrl}/real_estate_agents/loan_officers/${id}/membership`,
  realEstateAgentFavoriteLoanOfficersPath: () => `${baseUrl}/real_estate_agents/favorite_loan_officers`,
  realEstateAgentFavoriteLoanOfficerPath: id => `${baseUrl}/real_estate_agents/favorite_loan_officers/${id}`,
  realEstateAgentInviteBuyerPath: () => `${baseUrl}/real_estate_agents/invite_buyer`,
};



// WEBPACK FOOTER //
// ./src/routes/apiRoutes.js